<template>
  <ion-page style="overflow: auto;">
    <div>
      <fis-header></fis-header>
      <div class="container-fluid" id="itenary-div">
        <div class="row">
          <div class="col-sm-12" id="top-margin"></div>
        </div>

        <bread-crumbs v-bind:crumbs="searchBreadCrumbs"></bread-crumbs>
        <br>

        <!-- itenary -->
        <div class="row" id="large-screen">

          <smart-search :key="$route.query.name ? 'named-' + $route.fullPath : 'geography'"
                        v-bind:page="pageName" @clicked="loadedData"></smart-search>

          <div class="col-sm-7 col-md-8 col-lg-8 col-xl-6" id="sm-left-div" :class="{ 'is-directory': isBusiness }">

            <div class="container">
              <ion-list v-if="!loaded" style="margin-top: 4%">
                <ion-item v-for="n in 10" :key="n">
                  <ion-thumbnail slot="start">
                    <ion-skeleton-text :animated="true"></ion-skeleton-text>
                  </ion-thumbnail>
                  <ion-label>
                    <h3>
                      <ion-skeleton-text :animated="true" style="width: 80%;"></ion-skeleton-text>
                    </h3>
                    <p>
                      <ion-skeleton-text :animated="true" style="width: 60%;"></ion-skeleton-text>
                    </p>
                    <p>
                      <ion-skeleton-text :animated="true" style="width: 30%;"></ion-skeleton-text>
                    </p>
                  </ion-label>
                </ion-item>
              </ion-list>
              <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" v-if="loaded">
                <div class="row listing-header flex-nowrap">
                  <div class="col-auto listing-header__members" id="sponsors">
                    <h2>MEMBERS LISTING</h2>
                  </div>
                  <div class="col listing-header__directory" id="sponsors">
                    <div class="listing-header__toggle">
                      <ion-toggle mode="ios" @ionChange="switchBusiness" :checked="isBusiness"></ion-toggle>
                    </div>
                    <h2>SMART SEARCH DIRECTORY LIST</h2>
                  </div>
                </div>
                <div v-if="!isBusiness">
                  <div v-if="loadError" class="search-results-empty" aria-live="polite">
                    <p class="search-results-empty__text">{{ loadError }}</p>
                  </div>
                  <template v-else-if="introPanels.length">
                  <div class="row search-intro-panel g-0" id="business-card" v-for="(introPanel, panelIndex) in introPanels" :key="introPanel.id">

                    <div class="col-12 col-lg-4" id="card-img">
                      <div class="carousel">
                        <div class="carousel-inner">
                          <swiper :navigation="introPanel['images'].length > 1"
                                  :modules="modules" id="search-swipe">
                            <swiper-slide v-for="(images, slideIndex) in introPanel['images']" :key="images.id">
                              <img class="d-block"
                                   :src="storageBaseUrl + '/' + images['image']"
                                   :alt="introPanel.name || 'Listing image'"
                                   style="width: 100%"
                                   v-bind="introCarouselImgAttrs(panelIndex, slideIndex)">
                            </swiper-slide>
                          </swiper>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-lg-8" id="smart-search-text">

                      <h2 style="text-transform: uppercase"><a :href="'/smartcard/'+introPanel.id" target="_blank" > {{ introPanel.name }} </a></h2>
                      <div class="category-icons-row">
                        <img v-for="category in introPanel.categories" :key="category.id"
                             :src="storageBaseUrl + '/' + category.black_path"
                             :alt="category.name"
                             :title="category.name"
                             v-bind="lazyImageAttrs()">
                        <span class="intro-panel-save-label">Save</span>
                        <label :for="introPanel.id" class="custom-checkbox intro-panel-heart">
                          <input type="checkbox" :id="introPanel.id" @click="storeFavourites(introPanel.id, $event)"/>
                          <i class="fa fa-heart-o"></i>
                          <i class="fa fa-heart"></i>
                        </label>
                      </div>
                      <p v-if="introPanel.caption" class="capt-line-caption"><em style="color:#bba756;">{{ introPanel.caption }}</em></p>
                      <p v-if="introPanel.intro" class="capt-line-intro">{{ introPanel.intro }}</p>
                      <p v-if="introPanel.clean_address" class="address-line"><b>A:</b> {{ introPanel.clean_address }}</p>
                      <div class="intro-panel-contact-block" v-if="!shouldHidePhone(introPanel)">
                        <p class="ph"><b>{{ isAustralianMobile(introPanel.formatted_phone) ? 'M' : 'P' }}:</b> {{ introPanel.formatted_phone }}</p>
                        <p v-if="introPanel.formatted_mobile.length > 6" class="mb">
                          <b>M:</b>{{ introPanel.formatted_mobile }}</p>
                      </div>

                    </div>
                  </div>
                  </template>
                  <div v-else class="search-results-empty" aria-live="polite">
                    <p class="search-results-empty__text">No Data Available</p>
                  </div>
                </div>
                <div v-else class="directory-results">
                  <div v-if="loadError" class="search-results-empty" aria-live="polite">
                    <p class="search-results-empty__text">{{ loadError }}</p>
                  </div>
                  <template v-else-if="introBusinessPanels.length">
                  <div class="row visible-box search-business-panel g-0" id="business-mid-div" v-for="(businessPanel, bpIndex) in introBusinessPanels"
                       :key="businessPanel.id">
                    <div class="col-12 col-lg-3">
                      <img id="businesscard-img-1" v-if="businessPanel.images && businessPanel.images.length > 0"
                           :src="storageBaseUrl + '/' + businessPanel.images[0].image"
                           :alt="businessPanel.name"
                           v-bind="businessListingImgAttrs(bpIndex)">
                    </div>
                    <div class="col-12 col-lg-9" id="smart-text">
                      <h2 style="text-transform: uppercase; color: #34aade;"><b> {{ businessPanel.name }} </b></h2>
                      <p class="capt-line-caption"><em style="color:#bba756;">{{ businessPanel.caption }}</em></p>
                      <p class="address-line"><b>A:</b> {{ businessPanel.clean_address }}</p>
                      <div class="intro-panel-contact-block" v-if="!shouldHidePhone(businessPanel)">
                        <p class="ph"><b>{{ isAustralianMobile(businessPanel.formatted_phone) ? 'M' : 'P' }}:</b> {{ businessPanel.formatted_phone }}</p>
                        <p v-if="businessPanel.formatted_mobile.length > 6" class="mb">
                          <b>M:</b>{{ businessPanel.formatted_mobile }}</p>
                      </div>
                    </div>

                  </div>
                  </template>
                  <div v-else class="search-results-empty" aria-live="polite">
                    <p class="search-results-empty__text">No Data Available</p>
                  </div>
                </div>
                <div class="row">

                  <!-- Show More: only when there IS more data -->
                  <div :class="click > 1 ? 'col-sm-6 col-lg-6 text-center' : 'col-sm-12 col-lg-12 text-center'"
                       v-if="!isBusiness && introPanels.length > 1 && moreItems">
                    <button :class="click > 1 ? 'show-button' : 'show-button reduced-show-more'"
                            style="background-color:#34aade !important;" @click="showMore">Show More
                    </button>
                    <br><br>
                  </div>
                  <!-- Show Less: only after clicking Show More at least once -->
                  <div class="col-sm-6 col-lg-6 text-center mx-auto"
                       v-if="!isBusiness && click > 1 && introPanels.length > 1">
                    <button class="show-button" style="background-color:#34aade !important;" @click="showLess">Show Less
                    </button>
                    <br><br>
                  </div>
                  <!-- Show More: only when there IS more data (business) -->
                  <div :class="click > 1 ? 'col-sm-6 col-lg-6 text-center' : 'col-sm-12 col-lg-12 text-center'"
                       v-if="isBusiness && introBusinessPanels.length > 1 && moreItems">
                    <button :class="click > 1 ? 'show-button' : 'show-button reduced-show-more'"
                            style="background-color:#34aade !important;" @click="showMore">Show More
                    </button>
                    <br><br>
                  </div>
                  <!-- Show Less: only after clicking Show More at least once (business) -->
                  <div class="col-sm-6 col-lg-6 text-center mx-auto"
                       v-if="isBusiness && click > 1 && introBusinessPanels.length > 1">
                    <button class="show-button" style="background-color:#34aade !important;" @click="showLess">Show Less
                    </button>
                    <br><br>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <!-- itenary ends here -->

          <!-- Buisness names-->
          <sponsors-page :total-sponsors="6" class="mt-n1"></sponsors-page>

        </div>

      </div>

      <fis-footer></fis-footer>
    </div>
  </ion-page>
</template>

<script lang="ts">

import {defineComponent} from 'vue';
import fisHeader from "@/components/fisHeader.vue";
import fisFooter from "@/components/fisFooter.vue";
import sponsorsPage from "@/components/sponsorsPage.vue";
import {IonPage, IonToggle} from "@ionic/vue";
import breadCrumbs from "@/components/breadCrumbs.vue";
import SmartSearch from "@/components/search.vue";
import {Swiper, SwiperSlide} from 'swiper/vue';
import {Navigation} from "swiper";

import 'swiper/css';
import '@ionic/vue/css/ionic-swiper.css';
import "swiper/css/navigation";
import axios from "@/axios";
import {mapGetters, mapActions} from "vuex";
import { isAustralianMobile } from '@/utils/australianPhone';
import { introCarouselImgAttrs, lazyImageAttrs, businessListingImgAttrs } from '@/utils/imageLoading';
import { mergeUniqueById } from '@/utils/mergeUniqueById';


export default defineComponent({
  name: 'SmartSearchPage',
  components: {Swiper, SwiperSlide, SmartSearch, breadCrumbs, IonPage, IonToggle, fisHeader, fisFooter, sponsorsPage},
  props: {
    page: {
      default: 'smartcard'
    },
    crumbsList: {
      default: 'Australia'
    }
  },
  computed: {
    ...mapGetters({
      getItenary: 'itenary/getItenary',
    }),
    searchBreadCrumbs() {
      const finalCrumb = this.isBusiness ? 'Members Listing' : 'Members Display';
      const parts = String(this.breadCrumbs || '')
        .split(' > ')
        .map(crumb => crumb.trim())
        .filter(Boolean);

      const memberCrumbIndex = parts.findIndex(
        crumb => crumb === 'Members Listing' || crumb === 'Members Display'
      );
      if (memberCrumbIndex > -1) {
        parts[memberCrumbIndex] = finalCrumb;
      } else {
        parts.push(finalCrumb);
      }
      return parts.join(' > ');
    }
  },
  setup() {
    return {
      modules: [Navigation],
    };
  },
  created() {
    this.breadCrumbs = Object.keys(this.$route.query).map((key) => {
      return this.$route.query[key]
    }).join(' > ')
    if (this.$route.path == '/search/business-listing') {
      this.isBusiness = true
      this.pageName = 'businesslist'
    }
  },
  methods: {
    introCarouselImgAttrs,
    lazyImageAttrs,
    businessListingImgAttrs,
    isAustralianMobile,
    ...mapActions({
      addToItenary: 'itenary/addToItenary',
      removeFromItenary: 'itenary/removeFromItenary'
    }),
    async loadedData(value, breadCrumbArr) {
      this.click = 1
      this.loadError = ''
      let arr = [] as Array<any>;
      value.forEach(function (filter) {
        arr.push(encodeURIComponent(filter.name) + "=" + encodeURIComponent(filter.id))
      })
      this.query = arr.join('&')
      this.introPanels = []
      this.introBusinessPanels = []
      if (this.isBusiness) {
        await this.fetchBusinessPanels(this.query)
        this.pageName = 'businesslist'
      } else {
        await this.fetchIntroPanels(this.query);
      }
      this.createBreadCrumbs(breadCrumbArr);
      const el = this.$el as HTMLElement;
      el.scrollTo({ top: 0, behavior: 'smooth' });
    },
    showMore() {
      this.click = this.click + 1
      if (this.isBusiness) {
        this.fetchBusinessPanels(this.query)
      } else {
        this.fetchIntroPanels(this.query);
      }
    },
    showLess() {
      if (this.click > 1) {
        this.click = this.click - 1
      }
      if (this.isBusiness) {
        this.fetchBusinessPanels(this.query, false)
      } else {
        this.fetchIntroPanels(this.query, false);
      }
    },
    switchBusiness() {
      this.isBusiness = !this.isBusiness
      if (this.isBusiness) {
        this.pageName = 'businesslist'
        this.fetchBusinessPanels(this.query)
        this.$router.replace({
          path: '/search/business-listing?',
          query: this.$route.query
        })
      } else {
        this.$router.replace({
          path: '/search/smart-cards?',
          query: this.$route.query
        })
        this.pageName = 'smartcard'
        this.fetchIntroPanels(this.query)
      }
    },
    createBreadCrumbs(breadCrumbArr = []) {
      this.breadCrumbs = breadCrumbArr.join(' > ')
    },
    shouldHidePhone(card) {
      if (!card) return false;
      if (card.client_id === 1) return true;
      if (card.packages && card.packages.some((p: any) => p.id === 48 || p.id === 49)) return true;
      return false;
    },
    storeFavourites(id,event) {
      if(event.target.checked) {
        this.addToItenary(id);
      } else {
        this.removeFromItenary(id);
      }
    },
    async fetchIntroPanels(queryString, show = true) {
      const requestId = ++this.introRequestId
      this.loaded = false
      this.moreItems = true
      this.loadError = ''
      try {
        if (show && queryString) {
          const response = await axios.get("/smartcard/intro?page=" + this.click + "&" + queryString);
          if (requestId !== this.introRequestId) return
          this.introPanelLength = response.data.data.length
          const mergedPanels = mergeUniqueById(this.introPanels, response.data.data)
          this.introPanels = mergedPanels
          if(response.data.data.length === 0 || mergedPanels.length >= response.data.total) {
            this.moreItems = false;
          }
        } else if (queryString && !show) {
          this.introPanels = this.introPanels.slice(0, this.click * 10)
        }
      } catch (error) {
        if (requestId === this.introRequestId) {
          this.moreItems = false
          this.loadError = 'Unable to load members. Please try again.'
        }
      } finally {
        if (requestId === this.introRequestId) this.loaded = true
      }
    },
    async fetchBusinessPanels(queryString, show = true) {
      const requestId = ++this.businessRequestId
      this.loaded = false
      this.moreItems = true
      this.loadError = ''
      try {
        if (show && queryString) {
          const response = await axios.get("/businessList/intro?page=" + this.click + "&" + queryString);
          if (requestId !== this.businessRequestId) return
          this.businessPanelLength = response.data.data.length
          const mergedPanels = mergeUniqueById(this.introBusinessPanels, response.data.data)
          this.introBusinessPanels = mergedPanels
          if(response.data.data.length === 0 || mergedPanels.length >= response.data.total) {
            this.moreItems = false;
          }
        }  else if (queryString && !show) {
          this.introBusinessPanels = this.introBusinessPanels.slice(0, this.click * 15)
        }
      } catch (error) {
        if (requestId === this.businessRequestId) {
          this.moreItems = false
          this.loadError = 'Unable to load businesses. Please try again.'
        }
      } finally {
        if (requestId === this.businessRequestId) this.loaded = true
      }
    }
  },
  data() {
    return {
      storageBaseUrl: `${(process.env.VUE_APP_API_BASE_URL || '').replace(/\/+$/, '')}/storage`,
      loaded: false,
      introPanels: [] as Array<any>,
      introBusinessPanels: [] as Array<any>,
      isBusiness: false,
      query: '',
      breadCrumbs: this.crumbsList,
      pageName: this.page,
      click: 1,
      moreItems: false,
      loadError: '',
      introRequestId: 0,
      businessRequestId: 0,
      introPanelLength:0,
      businessPanelLength:0
    }
  }
});
</script>
<style>

ion-button {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 0.9rem;
  line-height: 1.6;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

ion-item {
  --min-height: 150px;
}

#businesscard-img-1 {
  width: 100%;
  height: 100%;
  min-height: 130px;
  display: block;
  margin-left: 0;
  border-radius: 15px 0px 0px 15px;
  object-fit: cover;
}

label {
  /* Presentation */
  font-size: 48px
}

/* Required Styling */

label input[type="checkbox"] {
  display: none;
}

.custom-checkbox {
  margin-left: 2em;
  position: relative;
  cursor: pointer;
}

.custom-checkbox .fa {
  color: rgb(52, 170, 222);
  position: absolute;
  font-size: 1.5em;
}

.custom-checkbox .fa-heart-o {
  color: gray;
}

.custom-checkbox .fa-heart {
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

.custom-checkbox:hover .fa-heart{
  opacity: 0.5;
}

.custom-checkbox input[type="checkbox"]:checked ~ .fa-heart {
  opacity: 1;
}
a:link {
  color: black;
  background-color: transparent;
  text-decoration: none;
}

/* Intro panels: override global fixed heights on #business-card / #smart-search-text from app.css */
#large-screen .search-intro-panel#business-card {
  height: auto !important;
  min-height: 0;
  align-items: stretch;
}

.intro-panel-contact-block {
  max-width: 230px;
  width: 100%;
  margin-top: 1%;
}

/* Intro panel text block spacing */
#large-screen .search-intro-panel #smart-search-text h2 {
  margin-bottom: 0.75rem;
}

#large-screen .search-intro-panel #smart-search-text .category-icons-row {
  margin-bottom: 0.75rem;
}

#large-screen .search-intro-panel #smart-search-text .capt-line-caption,
#large-screen .search-intro-panel #smart-search-text .capt-line-intro {
  margin-bottom: 0.75rem;
}

#large-screen .search-intro-panel #smart-search-text .capt-line-intro {
  font-size: 0.8rem;
}


#large-screen .search-intro-panel #smart-search-text .capt-line-caption em {
  font-weight: 900;
  font-style: italic;
}

#large-screen .search-intro-panel #smart-search-text > p {
  margin-bottom: 0.75rem;
}

#large-screen .search-intro-panel #smart-search-text .address-line {
  margin-bottom: 0.25rem;
}

#large-screen .search-intro-panel #smart-search-text .intro-panel-contact-block {
  margin-top: 0;
}

/* Category icons row: flex container aligning icons and heart */
#large-screen .search-intro-panel #smart-search-text .category-icons-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 4px;
}

/* Category icons: keep inline; global #smart-search-text img rules break this layout */
#large-screen .search-intro-panel #smart-search-text .category-icons-row img {
  position: static !important;
  display: inline-block;
  vertical-align: middle;
  width: 21px !important;
  height: auto !important;
  right: auto !important;
  bottom: auto !important;
  padding: 0 !important;
  margin-right: 0 !important;
}

#large-screen .search-intro-panel #smart-search-text {
  overflow-wrap: anywhere;
  word-break: break-word;
}

/* Favourite heart: circular badge, inline with category icons, pushed to the far right */
#large-screen .search-intro-panel .intro-panel-heart.custom-checkbox {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  float: none !important;
  clear: none;
  width: 21px;
  height: 21px;
  border-radius: 50%;
  border: 2px solid #34aade;
  padding: 0;
  margin: 0 !important;
  flex-shrink: 0;
}

#large-screen .search-intro-panel .intro-panel-heart.custom-checkbox .fa {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 12px;
  color: #34aade;
}

#large-screen .search-intro-panel .intro-panel-heart.custom-checkbox .fa-heart-o {
  color: #34aade;
  -webkit-text-stroke: 0.5px #34aade;
}

#large-screen .search-intro-panel .category-icons-row .intro-panel-save-label {
  color: #34aade;
  font-size: 13px;
  font-weight: 800;
  line-height: 1;
  cursor: pointer;
  margin-left: auto;
}

/* Desktop: fixed carousel height beside text */
@media (min-width: 992px) {
  #large-screen .search-intro-panel#business-card #card-img,
  #large-screen .search-intro-panel#business-card #smart-search-text {
    min-height: 250px;
  }

  #large-screen .search-intro-panel #card-img,
  #large-screen .search-intro-panel #card-img .carousel,
  #large-screen .search-intro-panel #card-img .carousel-inner,
  #large-screen .search-intro-panel #card-img .swiper,
  #large-screen .search-intro-panel #card-img .swiper-wrapper,
  #large-screen .search-intro-panel #card-img .swiper-slide {
    height: 250px !important;
  }

  #large-screen .search-intro-panel .d-block {
    height: 250px !important;
    width: 100%;
    object-fit: cover;
  }
}

/* Tablet / phone: stack image above text, drop fixed text column height */
@media (max-width: 991.98px) {
  #large-screen .search-intro-panel#business-card,
  #large-screen .search-intro-panel#business-card #card-img,
  #large-screen .search-intro-panel#business-card #smart-search-text {
    height: auto !important;
    min-height: 0 !important;
    max-height: none !important;
  }

  #large-screen .search-intro-panel #card-img .carousel-inner {
    border-radius: 15px 15px 0 0;
  }

  #large-screen .search-intro-panel #smart-search-text {
    border-radius: 0 0 15px 15px;
    padding-left: 3%;
    padding-right: 3%;
    padding-bottom: 0.75rem;
  }

  #large-screen .search-intro-panel #card-img .swiper,
  #large-screen .search-intro-panel #card-img .swiper-wrapper,
  #large-screen .search-intro-panel #card-img .swiper-slide {
    height: clamp(220px, 55vw, 340px) !important;
  }

  #large-screen .search-intro-panel .d-block {
    height: 100% !important;
    min-height: 200px !important;
    width: 100%;
    object-fit: cover;
  }
}

/* Business listing rows: stack below lg, fluid image */
#large-screen .search-business-panel#business-mid-div {
  height: auto !important;
  align-items: stretch;
  width: auto;
}

/* 13" screens (992px–1439px): compact card height */
@media (min-width: 992px) and (max-width: 1439px) {
  #large-screen .search-business-panel#business-mid-div {
    height: 160px !important;
    overflow: hidden !important;
  }
  #large-screen .search-business-panel#business-mid-div #businesscard-img-1 {
    height: 160px !important;
    width: 100% !important;
    object-fit: cover;
    margin-left: 0 !important;
    border-radius: 15px 0 0 15px;
  }
}

/* Standard desktop (1440px–2559px) */
@media (min-width: 1440px) and (max-width: 2559px) {
  #large-screen .search-business-panel#business-mid-div {
    height: 200px !important;
    overflow: hidden !important;
  }
  #large-screen .search-business-panel#business-mid-div #businesscard-img-1 {
    height: 200px !important;
    width: 100% !important;
    object-fit: cover;
    margin-left: 0 !important;
    border-radius: 15px 0 0 15px;
  }
}

/* 27"+ screens */
@media (min-width: 2560px) {
  #large-screen .search-business-panel#business-mid-div {
    height: 170px !important;
    overflow: hidden !important;
  }
  #large-screen .search-business-panel#business-mid-div #businesscard-img-1 {
    height: 170px !important;
    width: 100% !important;
    object-fit: cover;
    margin-left: 0 !important;
    border-radius: 15px 0 0 15px;
  }
}

/* Image column: flex so img fills full card height */
#large-screen .search-business-panel#business-mid-div > .col-12.col-lg-3 {
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
}

/* Text column: clip overflow on constrained height, pull content to top */
@media (min-width: 992px) {
  #large-screen .search-business-panel#business-mid-div #smart-text {
    overflow: hidden;
    padding-top: 14px !important;
  }
  #large-screen .search-business-panel#business-mid-div #smart-text h2 {
    margin-top: 0;
    margin-bottom: 0.2rem;
  }
  #large-screen .search-business-panel#business-mid-div #smart-text p {
    margin-bottom: 0.15rem;
  }
}

/* P and M stacked, left-aligned in directory listing */
#large-screen .search-business-panel#business-mid-div #smart-text .intro-panel-contact-block {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

#large-screen .search-business-panel#business-mid-div #smart-text .intro-panel-contact-block p {
  display: block;
  margin-bottom: 0.15rem;
}

#large-screen .search-business-panel #smart-text .capt-line-caption em {
  font-weight: 900;
}

#large-screen .search-business-panel #smart-text .address-line {
  font-weight: 700;
}

@media (max-width: 991.98px) {
  #large-screen .search-business-panel #businesscard-img-1 {
    width: 100%;
    max-width: none;
    height: clamp(220px, 55vw, 340px) !important;
    max-height: none;
    object-fit: cover;
    margin-left: 0 !important;
    border-radius: 15px 15px 0 0;
    display: block;
  }

  #large-screen .search-business-panel #smart-text {
    height: auto !important;
    min-height: 0 !important;
    border-radius: 0 0 15px 15px;
    padding-top: 0.5rem;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
}

/* Toggle: X when off (grey), checkmark when on (#34aade) — no new classes */
#large-screen #sm-left-div .row > #sponsors:last-child ion-toggle {
  width: 51px;
  height: 28px;
  --background: #e4e4e7;
  --background-checked: #34aade;
  --handle-width: 22px;
  --handle-height: 22px;
  --handle-spacing: 2px;
  --handle-background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23666666' d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/%3E%3C/svg%3E") center/60% no-repeat #fff;
  --handle-background-checked: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%2334aade' d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z'/%3E%3C/svg%3E") center/60% no-repeat #fff;
  box-shadow: 0 0 0 2px #000;
  border-radius: 999px;
}

#large-screen #sm-left-div .row > #sponsors:last-child ion-toggle.toggle-checked {
  box-shadow: none;
}

/* Shared listing header: switching modes must not move either heading. */
#large-screen #sm-left-div .listing-header {
  align-items: center;
  justify-content: space-between;
}

#large-screen #sm-left-div .listing-header h2 {
  margin: 0;
  line-height: 1.2;
}

#large-screen #sm-left-div .listing-header__members h2 {
  padding: 0 20px;
}

/* Directory images start at the card edge, so align its heading to that edge too. */
#large-screen #sm-left-div.is-directory .listing-header__members {
  padding-left: 0;
}

#large-screen #sm-left-div.is-directory .listing-header__members h2 {
  padding-left: 0;
}

#large-screen #sm-left-div .listing-header__directory {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-left: 0;
}

/* Narrow listing columns: stack the two header groups instead of overflowing. */
@media (max-width: 767.98px) {
  #large-screen #sm-left-div .listing-header {
    align-items: flex-start;
    flex-wrap: wrap !important;
    row-gap: 0.35rem;
  }

  #large-screen #sm-left-div .listing-header__members,
  #large-screen #sm-left-div .listing-header__directory {
    flex: 0 0 100%;
    max-width: 100%;
  }

  #large-screen #sm-left-div .listing-header__members h2 {
    padding: 0;
  }

  #large-screen #sm-left-div .listing-header__directory {
    align-items: flex-start;
    justify-content: flex-start;
  }
}

/* Section headings (MEMBERS, SPONSORS): font-weight/text-decoration set globally in app.css */


#large-screen #business-card h2 {
  text-decoration: underline;
  text-underline-offset: 0.12em;
}

#large-screen #business-mid-div h2 {
  text-decoration: none;
}

#large-screen #smart-search-text h2 a {
  text-decoration: underline;
  text-underline-offset: 0.12em;
  color: #34aade !important;
}

#large-screen .search-intro-panel #smart-search-text h2 {
  color: #34aade;
}

/* Empty search: fills listing area on page background */
#large-screen .search-results-empty {
  min-height: 240px;
  margin: 0.75rem 0 1.25rem;
  padding: 2.5rem 1.5rem;
  border-radius: 12px;
  background:
    linear-gradient(160deg, rgba(255, 255, 255, 0.45) 0%, rgba(235, 235, 238, 0.95) 42%, rgba(220, 223, 230, 0.65) 100%);
  border: 1px dashed rgba(0, 0, 0, 0.1);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

#large-screen .search-results-empty__text {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 500;
  color: #5a5f6b;
  letter-spacing: 0.03em;
}
</style>
